import { setupChatBox } from "../chat_box";

export function setupChatView(): void {
  setupChatBox();
}
